if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const openedMediaId = this.openedBy.getAttribute('data-media-id');

        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${openedMediaId}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(
          `[data-media-id="${openedMediaId}"]`
        );

        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;

        activeMedia.classList.add('active');

        const nebulaWrapper = activeMedia.closest('.nebula-modal-media');

        if (nebulaWrapper) {
          this.querySelectorAll('.nebula-modal-media').forEach((item) => {
            item.classList.remove('is-active');
          });

          nebulaWrapper.classList.add('is-active');

          const wrapperId = nebulaWrapper.getAttribute('data-nebula-media');

          this.querySelectorAll('.nebula-modal-thumbnail').forEach((thumb) => {
            thumb.classList.toggle(
              'nebula-modal-thumbnail--active',
              thumb.getAttribute('data-nebula-target') === wrapperId
            );
          });
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}